<template>
  <div class="navbar">
    <!-- 显示顶部面包屑图标做伸缩 -->
    <hamburger
      id="hamburger-container"
      :is-active="sidebar.opened"
      class="hamburger-container"
      @toggleClick="toggleSideBar"
    />
    <!-- 顶部面包屑 -->
    <breadcrumb id="breadcrumb-container" class="breadcrumb-container" />

    <div class="right-menu">
      <template v-if="device !== 'mobile'">
        <div class="right-menu-item">
          <!-- getUserDate此接口判断版本号，还没写接口到JS文件 -->
          <span class="ddt">{{ ddt }}</span>
          <!-- <div @click="getData">11</div> -->
        </div>
        <screenfull id="screenfull" class="right-menu-item hover-effect" />
      </template>
      <!-- 下拉菜单 -->
      <el-dropdown
        class="avatar-container right-menu-item hover-effect"
        trigger="click"
      >
        <!-- <div
          v-for="(item, index) in image"
          :key="index"
          class="avatar-wrapper"
        >
          <img :src="item.logo" class="user-avatar">
          <i class="el-icon-caret-bottom" />
        </div>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item split-button @click="logout">
            <span style="display: block">退出登录</span>
          </el-dropdown-item>
        </el-dropdown-menu> -->
        <div class="avatar-wrapper">
          <img :src="avatar" class="user-avatar" v-if="cid===0">
          <img :src="logo" class="user-avatar" v-else>
          <i class="el-icon-caret-bottom" />
        </div>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item divided @click.native="logout">
            <span style="display: block">退出登录</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Breadcrumb from '@/components/Breadcrumb/index'
import Hamburger from '@/components/Hamburger'
import Screenfull from '@/components/Screenfull'
import { application, accountCollectione } from '@/api/date'
export default {
  components: {
    Breadcrumb,
    Hamburger,
    Screenfull
  },
  data() {
    return {
       logo:require('@/assets/images/logo-new.png'),
      ddt: '',
      image: [],
      cid :this.$store.state.user.channelId
    }
  },
  computed: {
    ...mapGetters(['sidebar', 'avatar', 'device'])
  },
  created() {
    this.getUser()
    // this.getImage()
  },
  methods: {
    // getImage() {
    //   application()
    //     .then(res => {
    //       // this.image = res.data
    //       console.log(res.data)
    //       // this.$store.commit('SET_AVATAR', res.data[0].logo)
    //     })
    //     .catch(res => {})
    // },
    // 获取版本信息
    getUser() {
      accountCollectione({cate:2}).then((res)=>{
        this.ddt = res.data.name
      })
    },

    toggleSideBar() {
      this.$store.dispatch('app/toggleSideBar')
    },
    async logout() {
      var ssa = window.location.host
      let data={
        domain: ssa,
        type: 2,
        site_type: 7
      }
      await this.$store.dispatch('user/getssourl',data)
      await this.$store.dispatch('user/logout')
      var ht = document.location.protocol 
       let ssourl = this.$store.state.user.ssourl
      // 03.16git提示更改‘==’为‘===’
      if (ssa === 'localhost:9527') {
        window.location.href =
         ht+'//'+ssourl + '/api/v2/logout?redirect='+ht+'//' + ssa + '/login'
      } else {
        window.location.href =
          ht+'//'+ssourl +'/api/v2/logout?redirect='+ht+'//' + ssa + '/login'
      }
      // sessionStorage.removeItem('saveTitle')
    }
  }
}
</script>

<style lang="scss" scoped>
.ddt {
  height: 100%;
  font-size: 14px;
  color: red;
  font-weight: 700;
}
.navbar {
  height: 50px;
  overflow: hidden;
  position: relative;
  background: #fff;
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);

  .hamburger-container {
    line-height: 46px;
    height: 100%;
    float: left;
    cursor: pointer;
    transition: background 0.3s;
    -webkit-tap-highlight-color: transparent;

    &:hover {
      background: rgba(0, 0, 0, 0.025);
    }
  }

  .breadcrumb-container {
    float: left;
  }

  .errLog-container {
    display: inline-block;
    vertical-align: top;
  }

  .right-menu {
    float: right;
    height: 100%;
    // width: 100%;
    line-height: 50px;
    overflow: hidden;
    &:focus {
      outline: none;
    }

    .right-menu-item {
      display: inline-block;
      padding: 0 8px;
      height: 100%;
      font-size: 18px;
      color: #5a5e66;
      vertical-align: text-bottom;

      &.hover-effect {
        cursor: pointer;
        transition: background 0.3s;

        &:hover {
          background: rgba(0, 0, 0, 0.025);
        }
      }
    }

    .avatar-container {
      margin-right: 30px;

      .avatar-wrapper {
        margin-top: 5px;
        position: relative;

        .user-avatar {
          cursor: pointer;
          width: 40px;
          height: 40px;
          border-radius: 50%;
        }

        .el-icon-caret-bottom {
          cursor: pointer;
          position: absolute;
          right: -20px;
          top: 25px;
          font-size: 12px;
        }
      }
    }
  }
}
</style>
